/**
 * 전역 스크롤 위치 저장소
 * 애플리케이션 전체의 스크롤 위치를 관리
 */

const scrollPositions = new Map();

/**
 * @typedef {Object} ScrollPosition
 * @property {number} scrollY - Y 스크롤 위치
 * @property {number} timestamp - 저장된 시간
 * @property {string} route - 라우트 경로
 */
export const globalScrollStore = {
  /**
   * 라우트의 스크롤 위치 저장
   * @param {string} routePath - 라우트 경로
   * @param {number|null} scrollY - Y 위치 (기본값: window.scrollY)
   * @returns {ScrollPosition} 저장된 위치 데이터
   */
  savePosition(routePath, scrollY = null) {
    if (!routePath || typeof routePath !== 'string') {
      throw new Error('routePath must be a non-empty string');
    }
    
    const position = scrollY !== null ? scrollY : window.scrollY;
    const positionData = {
      scrollY: Math.max(0, Math.floor(position)),
      timestamp: Date.now(),
      route: routePath
    };
    
    scrollPositions.set(routePath, positionData);
    return positionData;
  },

  /**
   * 라우트의 저장된 스크롤 위치 조회
   * @param {string} routePath - 라우트 경로
   * @returns {ScrollPosition|null} 위치 데이터 또는 null
   */
  getPosition(routePath) {
    return scrollPositions.get(routePath);
  },

  /**
   * 라우트의 위치 존재 여부 확인
   * @param {string} routePath - 라우트 경로
   * @returns {boolean}
   */
  hasPosition(routePath) {
    return scrollPositions.has(routePath);
  },

  /**
   * 특정 라우트의 위치 삭제
   * @param {string} routePath - 라우트 경로
   * @returns {boolean} 삭제 성공 여부
   */
  clearPosition(routePath) {
    return scrollPositions.delete(routePath);
  },

  /** 저장된 모든 위치 삭제 */
  clearAll() {
    scrollPositions.clear();
  },

  /** 저장된 모든 위치 조회 (디버깅용) */
  getAllPositions() {
    return Object.fromEntries(scrollPositions);
  },

  /** 저장소 크기 조회 (디버깅용) */
  size() {
    return scrollPositions.size;
  }
};

export default globalScrollStore;